<div [loading]="loading">
  <div *ngIf="!loading">
    <fieldset>
      <legend>Základní údaje</legend>
      <div class="column-50" *ngIf="selectTitle">
        <!-- katastralni uzemi -->
        <gmt-input label="Katastrální území" [required]="true" class="mt-20">
          <gmt-select
            resource="areas"
            [filter]="{ sortOrder: { sortBy: 'name' }}"
            [data]="this"
            field="area"
            required="false"
            (changed)="onCadastreChanged()"
          ></gmt-select>
        </gmt-input>
      </div>
      <div class="column-50" *ngIf="selectTitle">
        <gmt-input label="LV" [required]="true" class="mt-20">
          <gmt-select
            resource="titles"
            [globalFilterConfig]="titleFilter"
            [data]="this"
            field="title"
            required="false"
            [itemPipe]="titleNamePipe"
            (changed)="onTitleChanged()"
          ></gmt-select>
        </gmt-input>
      </div>
      <div class="column-50">
        <div class="label" [ngClass]="{ required: !data.readonly }">Číslo znaleckého posudku</div>
        <div class="input" *ngIf="!data.readonly">
          <input type="text" [(ngModel)]="data.opinion.expertOpinionNumber"/>
        </div>
        <div class="info" *ngIf="data.readonly">{{ data.opinion.expertOpinionNumber }}</div>
      </div>
      <div class="column-50">
        <div class="label" [ngClass]="{ required: !data.readonly }">Datum vyhotovení</div>
        <div class="input" *ngIf="!data.readonly">
          <input pick-a-date type="text" [(ngModel)]="data.opinion.expertOpinionDate"/>
        </div>
        <div class="info" *ngIf="data.readonly">{{data.opinion.expertOpinionDate | date}}</div>
      </div>
    </fieldset>

    <expert-select-form *ngIf="!data.readonly" [expert]="data.opinion.expert" (changed)="onChangeExpert($event)"></expert-select-form>

    <fieldset *ngIf="data.opinionRequest && data.opinionRequest.lastStatusChangeDate && !data.readonly">
      <legend>Údaje o zpracování ZP</legend>
      <div class="column-50">
        <gmt-input label="Datum zadání zpracování" [required]="true" class="mt-10">
          <input type="text" pick-a-date [(ngModel)]="this.data.opinionRequest.realizationStartedDate"/>
        </gmt-input>
      </div>
      <div class="column-50">
        <gmt-input label="Termín pro vyhotovení" [required]="true" class="mt-10">
          <input type="text" pick-a-date [(ngModel)]="this.data.opinionRequest.realizationFinishExpectedDate"/>
        </gmt-input>
      </div>
      <div class="column-50">
        <gmt-input label="Datum vyhotovení" [required]="true" class="mt-10">
          <input type="text" pick-a-date [(ngModel)]="this.data.opinionRequest.realizedDate"/>
        </gmt-input>
      </div>
      <div class="column-50">
        <gmt-input label="Cena za vyhotovení" class="mt-10">
          <input type="text" [(ngModel)]="this.data.opinionRequest.realizationPrice" gmtInputNumber/>
        </gmt-input>
      </div>
    </fieldset>

    <fieldset *ngIf="data.opinionRequest && data.opinionRequest.lastStatusChangeDate && data.readonly">
      <div class="column-50">
        <label>Datum založení</label>
        <div class="info">{{ this.data.opinionRequest.createdDate | date }}</div>

        <label>Datum zadání zpracování</label>
        <div class="info">{{ this.data.opinionRequest.realizationStartedDate | date }}</div>

        <label>Termín pro vyhotovení</label>
        <div class="info">{{ this.data.opinionRequest.realizationFinishExpectedDate | date }}</div>

        <label>Datum vyhotovení</label>
        <div class="info">{{ this.data.opinionRequest.realizedDate | date }}</div>

        <label>Cena za vyhotovení</label>
        <div class="info">{{ this.data.opinionRequest.realizationPrice | price }}</div>
      </div>
    </fieldset>

    <fieldset *ngIf="data.readonly">
      <legend>Znalec</legend>
      <div class="column-50">
        <label>Titul před jménem</label>
        <div class="input">{{ data.opinion.expert.titulPredJmenem }}</div>
        <label>Křestní jméno</label>
        <div class="input">{{ data.opinion.expert.jmeno }}</div>
        <label>Příjmení</label>
        <div class="input">{{ data.opinion.expert.prijmeni }}</div>
        <label>Titul za jménem</label>
        <div class="input">{{data.opinion. expert.titulZaJmenem }}</div>
      </div>

      <div class="column-50">
        <label>Znalecká kancelář</label>
        <div class="input">{{ data.opinion.expert.kancelar }}</div>
        <label>Ulice</label>
        <div class="input">{{ data.opinion.expert.ulice }}</div>
        <label>Číslo orientační</label>
        <div class="input">{{ data.opinion.expert.cisloOrientacni }}</div>
        <label>Číslo popisné</label>
        <div class="input">{{ data.opinion.expert.cisloDomovni }}</div>
        <label>Město</label>
        <div class="input">{{ data.opinion.expert.obec }}</div>
        <label>PSČ</label>
        <div class="input">{{ data.opinion.expert.psc | postCode }}</div>
      </div>
    </fieldset>

    <fieldset *ngIf="data.opinion.occupationType === 'P' && multipleOpinionsPerParcelEnabled">
      <legend>Obsah znaleckého posudku</legend>
      <ul style="line-height: 1.5rem">
        <li>
          <div *ngIf="!data.readonly" (click)="data.opinion.expertOpinionLand = !data.opinion.expertOpinionLand">
            <gmt-checkbox [gmtChecked]="data.opinion.expertOpinionLand"></gmt-checkbox> cena zjištěná za pozemek nebo m<sup>2</sup> pozemku
          </div>
          <span *ngIf="data.readonly && data.opinion.expertOpinionLand">cena zjištěná za pozemek nebo m<sup>2</sup> pozemku</span>
        </li>
        <li>
          <div *ngIf="!data.readonly" (click)="data.opinion.expertOpinionVegetation = !data.opinion.expertOpinionVegetation">
            <gmt-checkbox [gmtChecked]="data.opinion.expertOpinionVegetation"></gmt-checkbox> cena zjištěná za porost (vedlejší úpravy) pozemku
          </div>
          <span *ngIf="data.readonly && data.opinion.expertOpinionVegetation">cena zjištěná za porost (vedlejší úpravy) pozemku</span>
        </li>
        <li>
          <div *ngIf="!data.readonly" (click)="data.opinion.expertOpinionBuildings = !data.opinion.expertOpinionBuildings">
            <gmt-checkbox [gmtChecked]="data.opinion.expertOpinionBuildings"></gmt-checkbox> cena zjištěná za stavbu(y) na pozemku
          </div>
          <span *ngIf="data.readonly && data.opinion.expertOpinionBuildings">cena zjištěná za stavbu(y) na pozemku</span>
        </li>
      </ul>
    </fieldset>

    <ng-container *ngIf="!data.opinionRequest && !data.opinion.id">
      <h2 style="font-size: 15px; padding-top: 0">Dokument znaleckého posudku <span class="required"></span></h2>
      <fileupload (change)="onFileChange($event)" [message]="filesMsg" inputId="opinionAttachmentsHidden"></fileupload>
    </ng-container>

    <gmt-attachments
      visibleByBrand="maja"
      *ngIf="data.opinionRequest"
      [defaultData]="{ opinionRequestId: data.opinionRequest.id }"
      [defaultAttachmentType]="attachmentType"
      [allowType]="false"
      [authorizedUser]="!data.readonly"
      [attachmentList]="attachmentList"
    ></gmt-attachments>

    <gmt-documents
      visibleByBrand="mpv"
      *ngIf="data.opinionRequest && documentList && documentList.list"
      [documentList]="documentList"
      [folder]="data.opinionRequest.folder"
      (updated)="loadDocuments();"
    ></gmt-documents>

    <div class="mt-30">
      <gmt-button [clickAction]="onSubmit" [gmtDisabled]="!isFormValid()">Pokračovat</gmt-button>
    </div>
  </div>
</div>
